import { render, staticRenderFns } from "./newsArticle.vue?vue&type=template&id=04529ca1&"
import script from "./newsArticle.vue?vue&type=script&lang=js&"
export * from "./newsArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/kinglinux/.baobaobot/teams/白/workspace_3GTAPP/projects/ita.GroupTravel.Website/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04529ca1')) {
      api.createRecord('04529ca1', component.options)
    } else {
      api.reload('04529ca1', component.options)
    }
    module.hot.accept("./newsArticle.vue?vue&type=template&id=04529ca1&", function () {
      api.rerender('04529ca1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ita/itaSetting/newsArticle.vue"
export default component.exports